var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#5458F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5889 7.75C12.5889 7.33579 12.2531 7 11.8389 7C11.4247 7 11.0889 7.33579 11.0889 7.75V11.0898H7.75C7.33579 11.0898 7 11.4256 7 11.8398C7 12.2541 7.33579 12.5898 7.75 12.5898H11.0889V15.9289C11.0889 16.3431 11.4247 16.6789 11.8389 16.6789C12.2531 16.6789 12.5889 16.3431 12.5889 15.9289V12.5898H15.9289C16.3431 12.5898 16.6789 12.2541 16.6789 11.8398C16.6789 11.4256 16.3431 11.0898 15.9289 11.0898H12.5889V7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGuest);
export default __webpack_public_path__ + "static/media/add-guest.68d3ffd4.svg";
export { ForwardRef as ReactComponent };